export default "__VITE_ASSET__BwzKUK_o__"